import React, { useState, useEffect } from "react";
import { FilePreviewProps } from "../constants/types";

const FilePreviewHandler: React.FC<
  FilePreviewProps & { contentType?: string }
> = ({ fileUrl, uploadedFile, isUploadedFile, onFileReady, contentType }) => {
  const [fileType, setFileType] = useState<string>("");
  const [fileData, setFileData] = useState<string | ArrayBuffer | null>(null);

  useEffect(() => {
    if (isUploadedFile && uploadedFile) {
      setFileType(uploadedFile.type);
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        setFileData(result);
        if (onFileReady) {
          onFileReady(result);
        }
      };
      reader.readAsDataURL(uploadedFile);
    } else if (fileUrl) {
      setFileData(fileUrl);
      if (onFileReady) {
        onFileReady(fileUrl);
      }
      const fetchFileType = async () => {
        try {
          if (!contentType) {
            const response = await fetch(fileUrl, { method: "HEAD" });
            const fetchedContentType = response.headers.get("Content-Type");
            setFileType(fetchedContentType || "unknown");
          } else {
            setFileType(contentType);
          }
        } catch (error) {
          console.error("Error fetching file type:", error);
        }
      };
      fetchFileType();
    }
  }, [isUploadedFile, uploadedFile, fileUrl, onFileReady, contentType]);

  const renderPreview = (): JSX.Element => {
    if (!fileType) return <p>Loading preview...</p>;

    const src = isUploadedFile ? (fileData as string) : fileUrl;

    if (fileType.startsWith("image/")) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            borderRadius: "8px",
          }}
        >
          <img
            src={src}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              borderRadius: "5px",
              padding: "14px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
      );
    }

    if (fileType === "application/pdf") {
      return (
        <iframe
          src={src}
          title="PDF Preview"
          style={{ width: "100%", height: "500px", border: "none" }}
        />
      );
    }

    if (fileType.startsWith("text/")) {
      return (
        <iframe
          src={src}
          title="Text Preview"
          style={{ width: "100%", height: "500px" }}
        />
      );
    }

    return <p>Unsupported file type for preview.</p>;
  };

  return <div>{renderPreview()}</div>;
};

export default FilePreviewHandler;
